function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 10.6c0-.91.486-1.75 1.274-2.206l12.215-7.053a2.548 2.548 0 012.548 0l12.216 7.053a2.548 2.548 0 011.274 2.207v5.751l-4.797-2.77a2.548 2.548 0 00-2.546-.002l-9.11 5.248a2.548 2.548 0 00-1.277 2.207v10.489c0 .855.43 1.65 1.136 2.12l-11.66-6.731A2.548 2.548 0 012 24.706V10.601z",
  fill: "url(#paint0_linear)"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.934 33.645l.555.32c.789.456 1.76.456 2.548 0l12.216-7.052a2.548 2.548 0 001.274-2.206v-8.355l4.284 2.475a2.548 2.548 0 011.273 2.206v10.493c0 .91-.485 1.75-1.273 2.206l-9.08 5.246a2.548 2.548 0 01-2.547.002l-9.11-5.248a2.569 2.569 0 01-.14-.087z",
  fill: "#96F"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M31.527 16.353l-4.797-2.771a2.548 2.548 0 00-2.546-.002l-9.11 5.248a2.548 2.548 0 00-1.277 2.208v10.488c0 .857.43 1.651 1.136 2.122l.556.32c.789.456 1.76.456 2.548 0l12.216-7.052a2.548 2.548 0 001.274-2.207v-8.354z",
  fill: "url(#paint1_linear)"
}), React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: "16.763",
  y1: "3.144",
  x2: "16.367",
  y2: "31.828",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#11EFE3"
}), React.createElement("stop", {
  offset: ".33",
  stopColor: "#15E8E2"
}), React.createElement("stop", {
  offset: ".74",
  stopColor: "#1FD3E0"
}), React.createElement("stop", {
  offset: "1",
  stopColor: "#21CFE0"
})), React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: "21.108",
  y1: "40.096",
  x2: "29.388",
  y2: "10.16",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#0048E5"
}), React.createElement("stop", {
  offset: ".64",
  stopColor: "#625AF5"
}), React.createElement("stop", {
  offset: "1",
  stopColor: "#8A62FC"
})))));